class ProductList {
  constructor() {
    this.init();
  }

  init() {
    this.setupScrolling();
    this.initializeQuantitySelectors();

    // 监听Shopify原生的购物车更新事件
    document.addEventListener("cart:updated", (event) => {
      this.syncAllQuantitySelectors();
    });
  }

  setupScrolling() {
    const containers = document.querySelectorAll(".product-list-wrapper");

    containers.forEach((container) => {
      // タッチデバイスでのスムーズスクロール
      let isDown = false;
      let startX;
      let scrollLeft;

      container.addEventListener("mousedown", (e) => {
        isDown = true;
        container.classList.add("active");
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener("mouseleave", () => {
        isDown = false;
        container.classList.remove("active");
      });

      container.addEventListener("mouseup", () => {
        isDown = false;
        container.classList.remove("active");
      });

      container.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;
      });
    });
  }

  async syncAllQuantitySelectors() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      // 遍历所有按钮，根据购物车状态更新UI
      const buttons = document.querySelectorAll(
        ".btn-add-to-cart[data-variant-id]"
      );

      buttons.forEach((button) => {
        const variantId = button.dataset.variantId;
        const cartItem = cart.items.find(
          (item) => item.variant_id == variantId
        );

        if (cartItem && cartItem.quantity > 0) {
          // 购物车中有此商品，显示数量选择器
          this.convertToQuantitySelector(button, variantId, cartItem.quantity);
        } else {
          // 购物车中没有此商品，显示ADD TO CART按钮
          if (button.classList.contains("btn-quantity-selector")) {
            this.resetToAddToCartButton(button, variantId);
          }
        }
      });
    } catch (error) {
      // エラーを静かに処理
    }
  }

  convertToQuantitySelector(button, variantId, quantity) {
    if (button.classList.contains("btn-quantity-selector")) {
      // 已经是数量选择器，只更新数字
      const display = button.querySelector(".quantity-display");
      if (display) {
        display.textContent = quantity;
      }
      return;
    }

    // 转换为数量选择器
    button.innerHTML = `
      <button type="button" class="quantity-btn quantity-minus" data-variant-id="${variantId}">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2 6h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <span class="quantity-display">${quantity}</span>
      <button type="button" class="quantity-btn quantity-plus" data-variant-id="${variantId}">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 2v8M2 6h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    `;

    button.classList.add("btn-quantity-selector");
    button.classList.remove("btn-add-to-cart");

    // 添加事件监听器
    this.setupQuantityControls(button, variantId);
  }

  setupQuantityControls(container, variantId) {
    const minusBtn = container.querySelector(".quantity-minus");
    const plusBtn = container.querySelector(".quantity-plus");

    minusBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.updateQuantity(variantId, -1);
    });

    plusBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      this.updateQuantity(variantId, 1);
    });
  }

  async updateQuantity(variantId, change) {
    try {
      // 获取当前购物车
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      const cartItem = cart.items.find((item) => item.variant_id == variantId);
      if (!cartItem) {
        return;
      }

      const currentQty = cartItem.quantity;
      const newQty = Math.max(0, currentQty + change);

      // 更新购物车
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: newQty,
        }),
      });

      if (response.ok) {
        // 同步所有数量选择器
        await this.syncAllQuantitySelectors();
      } else {
        throw new Error("Cart update failed");
      }
    } catch (error) {
      // エラーを静かに処理
    }
  }

  resetToAddToCartButton(button, variantId) {
    button.innerHTML = `
      <span class="btn-icon">+</span>
      <span class="btn-text">ADD TO CART</span>
    `;
    button.classList.remove("btn-quantity-selector");
    button.classList.add("btn-add-to-cart");
    button.dataset.variantId = variantId;
  }

  initializeQuantitySelectors() {
    // 页面加载时同步购物车状态
    this.syncAllQuantitySelectors();
  }
}

// DOMが読み込まれた後に初期化
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ProductList();
  });
} else {
  new ProductList();
}
